'use client'

import { useTheme } from 'next-themes'
import Image from 'next/image'
import { HTMLAttributes, useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

interface ThemeLogoProps extends HTMLAttributes<HTMLDivElement> {
  width?: number
  height?: number
}

export default function ThemeLogo({
  className,
  width = 120,
  height = 40,
  ...props
}: ThemeLogoProps) {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // After mounting, we can safely show the logo based on the theme
  useEffect(() => {
    setMounted(true)
  }, [])

  // Show placeholder during SSR to prevent hydration mismatch
  if (!mounted) {
    return (
      <div className={cn('relative', className)} style={{ width, height }} {...props} />
    )
  }

  const logoSrc = resolvedTheme === 'dark' ? '/Logo_Weiss.svg' : '/Logo_Schwarz.svg'

  return (
    <div className={cn('relative', className)} {...props}>
      <Image
        src={logoSrc}
        alt="Company Logo"
        width={width}
        height={height}
        className="h-full w-auto"
        priority
      />
    </div>
  )
} 